import React, { Component } from 'react';
import './AppShell.css';
import { logout } from '../services/authService';
import { SidebarNav } from './SidebarNav';

export class AppShell extends Component {
  static displayName = AppShell.name;

  handleLogout = () => {
    logout();
    window.dispatchEvent(new CustomEvent('authenticated'));
  };

  render() {
    const { children, variant } = this.props;

    return (
      <div className="app-shell">
        <aside className="app-shell__sidebar">
          <div className="app-shell__brand">
            <button
              type="button"
              className="app-shell__logout"
              onClick={this.handleLogout}
            >
              Cerrar sesión
            </button>
          </div>
          <SidebarNav variant={variant} onLogout={this.handleLogout} />
        </aside>

        <main className="app-shell__content">
          {children}
        </main>
      </div>
    );
  }
}
